"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Stack = _interopRequireDefault(require("../../../Stack"));
var _utils = require("../../utils");
var _ItemWrapper = _interopRequireDefault(require("../ItemWrapper"));
var _Month = _interopRequireDefault(require("./Month"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MONTHS_IN_ROW = 3;
var MonthSelectionView = function MonthSelectionView(_ref) {
  var current = _ref.current,
    isMonthSelected = _ref.isMonthSelected,
    isMonthDisabled = _ref.isMonthDisabled,
    onMonthSelect = _ref.onMonthSelect,
    onMonthFocus = _ref.onMonthFocus,
    onMonthHover = _ref.onMonthHover,
    focusedMonth = _ref.focusedMonth,
    _ref$isMonthHighlight = _ref.isMonthHighlighted,
    isMonthHighlighted = _ref$isMonthHighlight === void 0 ? function () {
      return false;
    } : _ref$isMonthHighlight,
    _ref$isMonthHighlight2 = _ref.isMonthHighlightStart,
    isMonthHighlightStart = _ref$isMonthHighlight2 === void 0 ? function () {
      return false;
    } : _ref$isMonthHighlight2,
    _ref$isMonthHighlight3 = _ref.isMonthHighlightEnd,
    isMonthHighlightEnd = _ref$isMonthHighlight3 === void 0 ? function () {
      return false;
    } : _ref$isMonthHighlight3;
  var emitChangeFocusedMonth = function emitChangeFocusedMonth(month) {
    if (!isMonthDisabled(month)) {
      onMonthFocus(month);
    }
  };
  var handleKeyDown = (0, _utils.useKeyDownHandler)(true, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _utils.keycode.ArrowUp, function () {
    return emitChangeFocusedMonth((0, _utils.addMonths)(focusedMonth, -MONTHS_IN_ROW));
  }), _utils.keycode.ArrowDown, function () {
    return emitChangeFocusedMonth((0, _utils.addMonths)(focusedMonth, MONTHS_IN_ROW));
  }), _utils.keycode.ArrowLeft, function () {
    return emitChangeFocusedMonth((0, _utils.addMonths)(focusedMonth, -1));
  }), _utils.keycode.ArrowRight, function () {
    return emitChangeFocusedMonth((0, _utils.addMonths)(focusedMonth, 1));
  }));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack["default"], {
    onKeyDown: handleKeyDown,
    direction: 'row',
    flexWrap: 'wrap',
    alignContent: 'stretch',
    justifyContent: 'center',
    margin: '4px 16px 0',
    width: 180,
    children: (0, _utils.getMonthArray)(current).map(function (month, i) {
      var selected = isMonthSelected(month);
      var disabled = isMonthDisabled(month);
      var highlight = isMonthHighlighted(month);
      var rowIndex = i % MONTHS_IN_ROW;
      var firstDateInLine = isMonthHighlightStart(month) || rowIndex === 0;
      var lastDateInLine = isMonthHighlightEnd(month) || rowIndex === 2;
      var focused = (0, _utils.isSameMonth)(month, focusedMonth);
      var monthProps = {
        'data-cy-value': (0, _utils.format)(month, 'LLL'),
        month: month,
        selected: selected,
        disabled: disabled,
        onFocus: function onFocus() {
          return emitChangeFocusedMonth(month);
        },
        focused: focused,
        tabIndex: focused || !i ? 0 : -1
      };
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ItemWrapper["default"], {
        value: month,
        onSelect: onMonthSelect,
        disabled: disabled,
        highlight: highlight,
        firstDateInLine: firstDateInLine,
        lastDateInLine: lastDateInLine,
        radius: '20px',
        onMouseEnter: onMonthHover ? function () {
          return onMonthHover(month);
        } : undefined,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Month["default"], _objectSpread({}, monthProps))
      }, month.toString());
    })
  });
};
var _default = exports["default"] = MonthSelectionView;